import { useEffect } from 'react';
import { SettingsFormState } from '../../reducer/settings-tree-reducer.types';
import { SettingsActionDispatcher } from '../../reducer/settings-tree.reducer';
import { DynamicForm } from '../form.types';

export function useRegisterDynamicForm(
  dynamicForm: DynamicForm | null,
  formState: SettingsFormState | null,
  dispatch: SettingsActionDispatcher
) {
  useEffect(() => {
    if (dynamicForm && dynamicForm.isLoading === false && formState?.isRegistered === false) {
      dispatch({
        type: 'REGISTER_FORM',
        payload: { nodeId: formState.nodeId, defaultValues: dynamicForm?.defaultValues || {} }
      });
    }
  }, [dispatch, dynamicForm, dynamicForm?.defaultValues, formState?.isRegistered, formState?.nodeId]);
}
